/**
 * ZoneForm 리포지토리
 * Zone API 호출 담당
 */
import { zoneApi, type Zone, type ZoneCreate, type ZoneUpdate } from '../../../services/zoneApi';

export class ZoneFormRepository {
  async createZone(data: ZoneCreate): Promise<Zone> {
    return await zoneApi.createZone(data);
  }

  async updateZone(zoneId: number, data: ZoneUpdate): Promise<Zone> {
    return await zoneApi.updateZone(zoneId, data);
  }

  async getZone(zoneId: number): Promise<Zone> {
    return await zoneApi.getZone(zoneId);
  }
}

export const zoneFormRepository = new ZoneFormRepository();
